import { render, staticRenderFns } from "./MoreLikeThis.vue?vue&type=template&id=0bbe3360&scoped=true&"
import script from "./MoreLikeThis.vue?vue&type=script&lang=js&"
export * from "./MoreLikeThis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe3360",
  null
  
)

export default component.exports